<script lang="ts" module>
  import { writable } from 'svelte/store';

  /** @type {Writable<string>} 成功・完了の通知メッセージ */
  export const msgToast: any = writable<string>('');
  /** @type {Writable<string>} 失敗の通知メッセージ(赤で表示) */
  export const msgToastError: any = writable<string>('');
</script>
<script lang="ts">
  import { onDestroy } from 'svelte';
  import { fly } from 'svelte/transition';

  /** @type {string} */
  let message:string = $state<string>('');

  /** @type {boolean} ディスプレイ識別子 */
  let show:boolean = $state<boolean>(false);

  /** @type {'success'|'error'} 表示種別 */
  let kind: 'success' | 'error' = $state<'success' | 'error'>('success');

  /** @type {ReturnType<typeof setTimeout> | null} 非表示タイマー(成功・失敗で共有し、後発の通知が先行タイマーで消されないよう毎回張り直す) */
  let hideTimer: ReturnType<typeof setTimeout> | null = null;

  /**
   * 通知を表示し、指定ミリ秒後に消す
   * @param {string} msg
   * @param {'success'|'error'} type
   * @param {number} duration
   */
  const display = (
    msg: string,
    type: 'success' | 'error',
    duration: number
  ): void => {
    if (null !== hideTimer) {
      clearTimeout(hideTimer);
    }
    kind = type;
    show = true;
    message = msg;
    hideTimer = setTimeout(() => {
      show = false;
      hideTimer = null;
    }, duration);
  };

  /**
   * ナビゲーションURLハンドラ
   * @param {string} msg
   */
  const handlerNaviUrl = (
    msg:string,
  ):void => {
    if (msg === '') return;
    msgToast.set('');
    display(msg, 'success', 2000);
  };

  /**
   * 失敗通知ハンドラ(赤で表示し、読めるよう少し長く出す)
   * @param {string} msg
   */
  const handlerError = (
    msg:string,
  ):void => {
    if (msg === '') return;
    msgToastError.set('');
    display(msg, 'error', 4000);
  };

  // 購読は初期化時に行い、破棄時に解除する(将来複数マウントされても購読が積み上がらない)
  onDestroy(msgToast.subscribe(handlerNaviUrl));
  onDestroy(msgToastError.subscribe(handlerError));
  onDestroy(() => {
    if (null !== hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
  });
</script>

{#if show}
<div class="fixed bottom-0 right-0 z-50" transition:fly={{ x:600, duration: 800 }}>
  <div class="{kind === 'error' ? 'bg-red-500' : 'bg-green'} rounded-lg shadow-lg px-6 py-4 flex items-center gap-3">
    <div class="bg-white/20 rounded-full p-1 bottom-0 right-0">
      {#if kind === 'error'}
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x h-5 w-5 text-white">
          <path d="M18 6 6 18"></path>
          <path d="m6 6 12 12"></path>
        </svg>
      {:else}
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check h-5 w-5 text-white">
          <path d="M20 6 9 17l-5-5"></path>
        </svg>
      {/if}
    </div>
    <span class="text-white font-medium text-base">{message}</span>
  </div>
  <br>
</div>
{/if}
